import styled from "styled-components";

import { FlexRow } from "@similarweb/ui-components";

export const StyledHeaderTitleContainer = styled(FlexRow)`
    gap: 8px;
`;
